// Paquete de idioma español
export default {
  // Común
  common: {
    learnMore: 'Más información',
    viewDetails: 'Ver detalles',
    backToTop: 'Volver arriba',
    loading: 'Cargando...',
    confirmSubmit: 'Confirmar envío',
    backToHome: 'Volver al inicio',
    backToPrevious: 'Volver',
    category: 'Categoría',
    all: 'Todo',
    wechatQrcode: 'Cuenta oficial de WeChat',
    emailAddress: 'Dirección de correo',
    copySuccess: 'Copiado con éxito',
    copy: 'Copiar',
    noData: 'Sin datos',
    noDataDesc: 'No hay contenido disponible en esta categoría',
  },

  // Idioma
  language: {
    zhCN: '简体中文',
    en: 'English',
    ja: '日本語',
    es: 'Español',
    fr: 'Français',
    selectLanguage: 'Seleccionar idioma',
  },

  // Menú de navegación
  nav: {
    home: 'Página de inicio',
    aboutUs: 'Sobre nosotros',
    companyIntro: 'Presentación de la empresa',
    awardsHonors: 'Premios y títulos',
    products: 'Centro de productos',
    coronaryBypass: 'Cirugía de derivación coronaria (CABG)',
    severeHeartDisease: 'Enfermedades cardíacas graves y circulación extracorpórea',
    vascularIntervention: 'Intervención vascular',
    academic: 'Información académica',
    newProducts: 'Nuevos productos',
    clinicalRelated: 'Relacionado con la clínica',
    academicFrontier: 'Frontera académica',
    news: 'Noticias corporativas',
    newsExpress: 'Noticias express',
    awards: 'Premios',
    financingAnnouncement: 'Anuncio de financiación',
    contactUs: 'Contáctanos',
  },

  // Página de inicio
  home: {
    // Banner
    bannerSlogan: 'Donde llega YueWei, lo complejo se simplifica',
    bannerSloganHighlight: 'simplifica',

    // Soluciones de productos
    productSolutions: 'Soluciones de productos',
    productCenter: 'Centro de productos',
    coronaryBypass: 'CABG',
    severeHeartDisease: 'Enfermedad cardíaca grave',
    severeHeartDiseaseAndECMO: 'Enfermedades cardíacas graves y circulación extracorpórea',
    severeHeartDiseaseMobile: 'Enfermedad cardíaca grave<br>y circulación extracorpórea',
    vascularIntervention: 'Intervención vascular',

    // Nuestra visión
    ourVision: 'Nuestra visión',
    aboutUs: 'Sobre nosotros',
    visionTitle1: 'INNOVACIÓN',
    visionText1: 'NACE DE NECESIDADES CLÍNICAS',
    visionTitle2: 'INGENIO',
    visionText2: 'CONSTRUYE UN FUTURO SALUDABLE',

    // Historia de desarrollo
    developmentHistory: 'Historia de desarrollo',
    timeline: {
      year2021: 'Yuewei Medical fundada en Pekín',
      year2023_1: 'Empresa de alta tecnología de Zhongguancun',
      year2023_2: 'Empresa de alta tecnología de nivel nacional',
      year2023_3: 'PYME tecnológica reconocida por el Ministerio de Ciencia y Tecnología',
      year2024_1: 'PYME especializada e innovadora de Beijing',
      year2024_2: 'Empresa líder anual (industria) del Foro Empresarial de Boao',
      year2024_3: 'Asociación de Fondos de Beijing <Caso excelente de inversión sostenible 2024>',
    },

    // Noticias empresariales
    newsCenter: 'Centro de noticias',
    enterpriseDynamics: 'Noticias corporativas',
    corporateHonors: 'Honores corporativos',
    capitalDynamics: 'Dinámicas de capital',
    strategicCooperation: 'Cooperación estratégica',
    newsTitle: 'Yuewei Medical obtiene casi 100 millones de RMB en financiación de Serie A++ para acelerar el proceso completo de diagnóstico y tratamiento de enfermedades cardíacas coronarias graves',
    newsCategory: 'Anuncio de financiación',
    newsDate: '2025/12/07',
    newsDesc: 'Publicar desarrollo de la empresa, proyectos de cooperación e información externa importante',

    // Información académica
    academicInfo: 'Información académica',
    clinicalResearch: 'Investigación clínica',
    literatureInterpretation: 'Interpretación de literatura',
    academicPromotion: 'Promoción académica',
    academicTitle1: 'Nuevos productos',
    academicTitle2: 'Relacionado con la clínica',
    academicTitle3: 'Frontera académica',
    academicDesc1: 'Redefiniendo velocidad y precisión | Nuevo estabilizador cardíaco YueWei lanzado oficialmente',
    academicDesc2: 'IA impulsando el diagnóstico y tratamiento de precisión de enfermedades coronarias - Mirando hacia 2026',
    academicDesc3: 'Perspectivas clínicas globales - El 12º ICEF se inaugura grandiosamente en Beijing',
    academicDetailText: 'Centrarse en investigación clínica relacionada con productos, evidencia académica y contenido de intercambio académico',
  },

  // Página Sobre nosotros
  about: {
    aboutYuewei: 'Sobre YueWei',
    mission: 'Misión',
    missionText1: 'Convertirse en un socio de confianza',
    missionText2: 'en cirugía cardiovascular',
    vision: 'Visión',
    visionText1: 'INNOVACIÓN',
    visionText2: 'NACE DE NECESIDADES CLÍNICAS',
    visionText3: 'INGENIO',
    visionText4: 'CONSTRUYE UN FUTURO SALUDABLE',
    values: 'Valores',
    valuesText1: 'A través de la innovación continua',
    valuesText2: 'Empoderar a los cirujanos,',
    valuesText3: 'Para más pacientes',
    valuesText4: 'Abrir nueva esperanza de vida',
    awardsAndTitles: 'Premios y títulos',
    companyIntro: 'Yuewei Medical fue fundada en septiembre de 2021 por cirujanos cardíacos del Hospital Anzhen junto con ejecutivos senior de empresas líderes de dispositivos médicos nacionales e internacionales. Es una empresa de alta tecnología enfocada en I+D, fabricación y ventas de dispositivos médicos de cirugía cardiovascular. La empresa ha sido reconocida como Empresa Nacional de Alta Tecnología y PYME "Especializada e Innovadora" de Beijing.',
    productIntro: 'Los productos principales actuales se dividen en tres sectores principales:',
    productLine1Title: 'Sector de Cirugía de Enfermedades Coronarias',
    productLine1Desc: ', con medidores de flujo sanguíneo coronario y estabilizadores cardíacos de próxima generación como núcleo, desplegando casi diez instrumentos quirúrgicos, logrando una cobertura completa de consumibles de alto valor en cirugía coronaria;',
    productLine2Title: 'Sector de Enfermedades Cardíacas Graves y Circulación Extracorpórea',
    productLine2Desc: ', con la tecnología y materiales de cánula de alta gama desarrollados por Yuewei como núcleo, desplegando múltiples productos pioneros nacionales incluyendo cánulas arteriovenosas femorales de pared delgada y cánulas venosas de doble lumen;',
    productLine3Title: 'Sector de Tratamiento de Trombosis Venosa Profunda',
    productLine3Desc: ', este sector es un diseño estratégico que la empresa comenzó a través de adquisiciones en 2024, desplegando dos dispositivos médicos innovadores en torno al tratamiento de trombosis venosa profunda.',
    companyMotto: 'Desde su establecimiento, Yuewei Medical siempre ha seguido la filosofía de desarrollo de "La innovación surge de las necesidades clínicas, la destreza construye un futuro saludable", y está comprometida a convertirse en líder en instrumentos quirúrgicos cardiovasculares graves de China.',
  },

  // Página de Premios y Títulos
  prize: {
    title: 'Premios y Títulos',
    aboutYuewei: 'Sobre YueWei',
    viewDetails: 'Ver detalles',
    awards: {
      award1: {
        year: '2023',
        title: 'Empresa de Alta Tecnología de Zhongguancun',
      },
      award2: {
        year: '2023',
        title: 'Empresa Nacional de Alta Tecnología',
      },
      award3: {
        year: '2023',
        title: 'PYME Tecnológica del Ministerio de Ciencia',
      },
      award4: {
        year: '2024',
        title: 'PYME Especializada e Innovadora de Beijing',
      },
      award5: {
        year: '2024',
        title: 'Empresa Líder Anual del Foro Boao',
      },
      award6: {
        year: '2024',
        title: 'Asociación de Fondos de Beijing',
        subtitle: '<Caso Excelente de Inversión Sostenible 2024>',
      },
    },
  },

  // Página de Productos
  products: {
    productDetails: 'Detalles del producto',
    productCenter: 'Centro de productos',
    categories: {
      coronaryBypass: 'Derivación Coronaria',
      severeHeartDisease: 'Enfermedad Cardíaca Grave y ECMO',
      vascularIntervention: 'Intervención Vascular',
    },
    items: {
      heartStabilizer: {
        name: 'Estabilizador Cardíaco',
        code: '[No. de Registro] JXYZ 20242030034',
      },
      coronaryImaging: {
        name: 'Software de Imagen de Angiografía Coronaria',
        code: '[No. de Registro] JXYZ 20242210076',
      },
      endoscopeVessel: {
        name: 'Sistema de Recolección de Vasos Endoscópico*',
        code: '*Este producto aún no está disponible en China',
      },
      proximalAnastomosis: {
        name: 'Sistema de Anastomosis Proximal**',
        code: '*Este producto aún no está disponible en China',
      },
      ultrasonicFlowmeter: {
        name: 'Medidor de Flujo Sanguíneo Ultrasónico (TTFM+ECUS)*',
        code: '*Este producto aún no está disponible en China',
      },
    },
  },

  // Página de Detalle de Producto
  productDetail: {
    productCenter: 'Centro de productos',
    title: 'Estabilizador Cardíaco',
    subtitle: 'Estabilizador Cardíaco Modular y Multifuncional',
    code: '[No. de Registro] JXYZ 20242030034',
    description: 'Este es el contenido de texto enriquecido de introducción del producto mantenido en el backend. Este es el contenido de texto enriquecido de introducción del producto mantenido en el backend. Este es el contenido de texto enriquecido de introducción del producto mantenido en el backend.',
  },

  // Página Contáctanos
  contact: {
    title: 'Contáctanos',
    yourName: 'Nombre',
    enterYourName: 'Nombre',
    yourPhone: 'Número de teléfono',
    enterYourPhone: 'Número de teléfono',
    yourCompany: 'Empresa',
    enterYourCompany: 'Empresa',
    yourMessage: 'Mensaje',
    enterYourMessage: 'Mensaje',
    privacyAgreement: 'Acepto que Yuewei Medical procese mis datos personales y declaro que he leído la política de privacidad',
    submitSuccess: 'Envío exitoso',
    validation: {
      nameRequired: 'Por favor, ingrese su nombre',
      phoneRequired: 'Por favor, ingrese su número de teléfono',
      companyRequired: 'Por favor, ingrese su empresa',
      messageRequired: 'Por favor, ingrese su mensaje',
      agreeRequired: 'Por favor, acepte la política de privacidad',
    },
    companyName: 'Beijing YueWei Medical Technology Co., Ltd.',
    address: 'Centro Creativo Huashang, No. 18 Calle Keyuan, Zona de Desarrollo Económico, Distrito Daxing, Pekín',
  },

  // Página de Noticias
  news: {
    title: 'Anuncios de Noticias',
    categories: {
      all: 'Todo',
      newsExpress: 'Noticias Express',
      awards: 'Premios',
      financing: 'Anuncios de Financiación',
    },
  },

  // Página Académica
  academic: {
    title: 'Innovación Médica',
    categories: {
      all: 'Todo',
      newProducts: 'Nuevos Productos',
      clinical: 'Relacionado Clínico',
      frontier: 'Frontera Académica',
    },
  },

  // Pie de página
  footer: {
    companyName: 'Beijing YueWei Medical Technology Co., Ltd.',
    companyNameEn: 'Beijing Yuewei Medical Technology Co., Ltd',
    address: 'Dirección: Centro Creativo Huashang, No. 18 Calle Keyuan, Zona de Desarrollo Económico, Distrito Daxing, Pekín',
    addressShort: 'Dirección: No. 18 Calle Keyuan, Distrito Daxing, Pekín',
    copyright: 'Copyright © 2025 Beijing YueWei Medical Technology Co., Ltd.',
    icp: 'Registro ICP: ',
    icpNumber: 'Jing ICP Bei 2025155672-1',
    securityNumber: 'Jing Red Pública Segura 11011502039384',
    medicalLicense: 'Número de registro del servicio de información de red de dispositivos médicos: ',
    medicalLicenseNumber: '(Jing) Registro de información de dispositivos médicos en línea (2024) No. 00322',
  },
}
